import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'os_hub_id'

export const dataPointDefinition = {
  retracedId: 'os_hub_id',
  name: 'OS Hub ID',
  description:
    'The Open Supply Hub (OS Hub), formerly known as Open Apparel Registry (OAR), is an open source tool mapping facilities worldwide and allocating a unique ID to each. See more information at https://www.opensupplyhub.org/ to a) identify your OS ID or b) submit your facility data to obtain your free OS ID. \r\r\nIf you do not have an OS ID, answer Not Applicable.',
  meta: {},
  fieldTypeId: 'SHORT_TEXT',
  type: 'GLOBAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-oar-1',
      version: '1.4.2',
      provider: 'slcp',
    },
  ],
  sortingId: 390,
  sectionId: '1.2',
  impactArea: 'Other IDs',
  impactAreaId: 'OTHER_IDS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
